module.exports = __webpack_public_path__ + "static/img/15.33c5b91.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/sp/15.png
// module id = ygL6
// module chunks = 0